<template>
  <div class="jira-cloud-step-3">

    <div class="row">
      <div class="col-12">
        <h2>Please select your preferences</h2>
      </div>
    </div>

    <JiraFieldsMapping/>


    <div class="row">
      <div class="col-12">
        <div class="config-footer flex-end">
          <div class="button-group">
            <ButtonElement class="btn--ms btn--silent-tertiary btn--regular" @click="$emit('cancelClick')">Back</ButtonElement>
            <ButtonElement class="btn--ms btn--accent" @click="finishIntegration()">Finish Integration
            </ButtonElement>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script lang="ts">
import {defineComponent} from 'vue';
import ButtonElement from '@shared/components/elements/button/button.element.vue';
import JiraFieldsMapping from './components/jira-fields-mapping.vue';

export default defineComponent({
  name: 'JiraCloudStep4',
  components: {
    ButtonElement,
    JiraFieldsMapping,
  },
  emits: ['cancelClick', 'continueClick'],
  props: {
    selectedProjectKey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dontImportNow: false,
    };
  },
  methods: {
    finishIntegration() {
      this.$emit('continueClick', !this.dontImportNow);
    },
  },
});
</script>
<style lang="scss" scoped>
  h2{
    margin-bottom: var(--space-32);
  }
</style>